import { BlightChartDetailsDay } from 'src/app/blight-v2/models/models';
import {
  getAdvice,
  getSprayTypeStyling,
  getSprayTypeTranslation,
} from 'src/app/blight-v2/shared/helpers/spray.helpers';
import { DiseaseChartDay } from 'src/app/shared/components/disease-insight-chart/models';

export function mapBlightDaysToChartDays(
  days: BlightChartDetailsDay[],
  requestedDates: Date[] = days.map(({ date }) => date),
): DiseaseChartDay[] {
  return requestedDates.map((date) => {
    const day = days.find((candidate) => isSameDay(candidate.date, date));
    if (!day) {
      const sprayAdvice = getAdvice(-1);

      return {
        date,
        adviceTranslationKey: getSprayTypeTranslation({
          date,
          sprayAdvice,
          remainingFungicidePercentage: 0,
          isSprayedToday: false,
        }),
        adviceStylingOverride: getSprayTypeStyling({
          date,
          sprayAdvice,
          remainingFungicidePercentage: 0,
          isSprayedToday: false,
        }),
      };
    }

    const sprayAdvice = getAdvice(day.sprayType);

    return {
      date: day.date,
      sprayType: day.sprayType,
      fungicideLeftPct: day.fungicideLeftPct,
      sprayTime: day.sprayTime,
      infectionRiskPerHour: day.infectionRiskPerHour,
      weather: day.weather,
      sprayEffectivity: day.sprayEffectivity,
      unprotectedGrowth: day.unprotectedGrowth,
      tuberInfectionRisk: day.tuberInfectionRisk,
      ooSporesRisk: day.ooSporesRisk,
      adviceTranslationKey: getSprayTypeTranslation({
        date: day.date,
        sprayAdvice,
        remainingFungicidePercentage: day.fungicideLeftPct,
        isSprayedToday: !!day.sprayTime,
      }),
      adviceStylingOverride: getSprayTypeStyling({
        date: day.date,
        sprayAdvice,
        remainingFungicidePercentage: day.fungicideLeftPct,
        isSprayedToday: !!day.sprayTime,
      }),
    };
  });
}

const isSameDay = (first: Date, second: Date): boolean =>
  first.getFullYear() === second.getFullYear() &&
  first.getMonth() === second.getMonth() &&
  first.getDate() === second.getDate();
